export const VOUCHER_ONBOARDING_PLATFORM_IBK = 'IBK';
export const VOUCHER_ONBOARDING_PLATFORM_SUPER_APP = 'SUPER_APP';
export const VOUCHER_ONBOARDING_TYPE_WELCOME = 'WELCOME';
export function computeShouldShowBenefitsOnboardingEntry({ enabled, hasActiveContract, isEligible, isQuerySkipped, isQueryError, isQueryLoading, isQueryFetching, isQueryUninitialized, onboardingItems, }) {
    if (!enabled || !hasActiveContract || !isEligible) {
        return false;
    }
    if (isQuerySkipped) {
        return false;
    }
    if (isQueryError) {
        return false;
    }
    const isPending = isQueryLoading || isQueryFetching || (isQueryUninitialized && !isQueryError);
    if (isPending) {
        return false;
    }
    const welcome = onboardingItems?.find(i => i.type === VOUCHER_ONBOARDING_TYPE_WELCOME);
    if (welcome?.completed === true) {
        return false;
    }
    return true;
}
